import axios from "axios";
import { ApiConfig } from "../Config/config";
import { attachRequestInterceptor } from "./interceptor";

const axiosClient = axios.create({
  baseURL: ApiConfig.baseUrl,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// Optional: Add request interceptors
axiosClient.interceptors.request.use(
  attachRequestInterceptor,
  (error) => Promise.reject(error)
);

// Optional: Add response interceptors
axiosClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle common errors globally
    if (error.response?.status === 401) {
      // Redirect to login or refresh token
      console.error("Unauthorized access - redirect to login");
    }
    return Promise.reject(error);
  }
);

export default axiosClient;